import React, { useEffect, useMemo, useState } from "react";
import { View, StyleSheet, Text, ScrollView } from "react-native";
import { IconButton } from "react-native-paper";
import { useAuth } from "../../../providers/AuthProvider";
import { useKpiConfig } from "./kpi/useKpiConfig";
import DbObservation from "./Observation";
import DbEnergyLog from "./EnergyLog";
import { CommonStyles } from "./ConsolidatedController";
import DbWaterLog from "./WaterLog";
import DbWasteLog from "./WasteLog";
import DbWasteWaterLog from "./WasteWaterLog";
import DbSpoilLog from "./SpoilLog";
import DbHazardousMaterial from "./HazardousMaterial";
import DbImportedSoilLog from "./ImportedSoilLog";
import DbRecycledMaterial from "./RecycledMaterial";
import DbRegionalMaterial from "./RegionalMaterial";
import DbNoiseLog from "./NoiseLog";
import DbPM10 from "./PM10Monitoring";
import DbVibrationLog from "./VibrationMonitoring";
import DbTrainingLog from "./TrainingLog";
import ButtonControl from "../common/controls/Button";
import LogDateRangeFilter from "../common/controls/LogDateRangeFilter";
import { SingleSelectDropdown } from "../common/controls/Dropdown-filter";
import { DbPM2P5 } from "./PM2P5Monitoring";
import { useNav } from "../../../providers/NavProvider";
import DashboardKPISection from "./kpi/DashboardKPISection";
interface LogProps {
  setModalVisible?: any;
  modalVisible?: boolean;
  clientAPIURL: string;
  Source?: string;
  ContinueToSite?: () => void;
  sitesResp: any;
  projectId:string;
}
export const HomeDashboard: React.FC<LogProps> = ({ clientAPIURL, setModalVisible, modalVisible, Source, ContinueToSite, sitesResp, projectId }) => {

  const { getAccessToken } = useAuth();
  const [accessToken, setAccessToken] = useState(null);
  const [dateRange, setDateRange] = useState<{ start: Date | null; end: Date | null }>(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return { start: new Date(today.getTime() - 180 * 86400000), end: today };
  });
  const [selectedPackages, setSelectedPackages] = useState<string[]>([]);
  const emptyData = useMemo(() => [], []);

  useEffect(() => {
    async function fetchData() {
      setAccessToken(await getAccessToken());
    }
    fetchData();
  }, []);

  const kpiConfig = useKpiConfig(clientAPIURL, accessToken, projectId);

  const packages = useMemo(() => {
    if (!sitesResp) return [{ label: 'All Packages', value: 'ALL' }];
    const excluded = kpiConfig.excludedPackageKeywords.map(k => k.toLowerCase());
    const isPackageNode = (c: any) =>
      (c.path || '').split('-').length === 3 &&
      !excluded.some(k => (c.title || '').toLowerCase().includes(k));
    const sites = projectId === sitesResp.id
      ? (sitesResp.children || []).filter((c: any) => c.type === 'site')
      : (sitesResp.children || []).filter((c: any) => c.id === projectId);
    const pkgNodes = sites
      .flatMap((s: any) => (s.children || []).filter(isPackageNode))
      .sort((a: any, b: any) => (a.title || '').localeCompare(b.title || ''));
    return pkgNodes.map((p: any) => ({ label: p.title, value: p.title }));
  }, [sitesResp, projectId, kpiConfig.excludedPackageKeywords]);

  const continueToSite = () => {
    ContinueToSite();
  }
  return (
    <ScrollView style={{ backgroundColor: '#fff' }}>
      <View>
        <View style={{ flexDirection: 'row', gap: 10, alignItems: 'center', justifyContent: 'flex-end', flexWrap: 'wrap', zIndex: 200 }}>
          <View style={{ zIndex: 200 }}>
            <LogDateRangeFilter
              data={emptyData}
              onFilterChange={() => {}}
              onRangeChange={(s, e) => setDateRange({ start: s, end: e })}
              defaultPreset="LAST_6M"
            />
          </View>
          <SingleSelectDropdown
            options={packages}
            label="All Packages"
            selected={selectedPackages}
            onSelect={(v) => setSelectedPackages(v as string[])}
            menuAlign="right"
            isMulti
          />
          {sitesResp && <ButtonControl icon={'arrow-right-circle-outline'} Title={'Packages'} mode={'contained'} onPress={() => { Source === 'Client' ? continueToSite() : setModalVisible(!modalVisible) }} disabled={false} />}
        </View>
        {
          (accessToken) ?
            <View>
              <DashboardKPISection
                accessToken={accessToken}
                clientAPIURL={clientAPIURL}
                projectId={projectId}
                dateRange={dateRange}
                selectedPackage={selectedPackages.length === 0 ? null : selectedPackages}
              />
            </View>
            : null
          }
          {
          // (accessToken) ?
          //   <View style={CommonStyles.container}>
          //     <View style={CommonStyles.card}>
          //       <DbObservation dateRange={dateRange} selectedPackage={selectedPackages.length === 0 ? null : selectedPackages} logTitle={"Environmental Issues Observations"} accessToken={accessToken} clientAPIURL={clientAPIURL} projectId={projectId} /></View>
          //     <View style={CommonStyles.card}>
          //       <DbEnergyLog dateRange={dateRange} selectedPackage={selectedPackages.length === 0 ? null : selectedPackages} logTitle={"Energy Log"} accessToken={accessToken} clientAPIURL={clientAPIURL} projectId={projectId} /></View>
          //     <View style={CommonStyles.card}>
          //       <DbWaterLog dateRange={dateRange} selectedPackage={selectedPackages.length === 0 ? null : selectedPackages} logTitle={"Water Log"} accessToken={accessToken} clientAPIURL={clientAPIURL} projectId={projectId} /></View>
          //     <View style={CommonStyles.card}>
          //       <DbWasteWaterLog dateRange={dateRange} selectedPackage={selectedPackages.length === 0 ? null : selectedPackages} logTitle={"Wastewater Tracking Log"} accessToken={accessToken} clientAPIURL={clientAPIURL} projectId={projectId} /></View>
          //     <View style={CommonStyles.card}>
          //       <DbWasteLog dateRange={dateRange} selectedPackage={selectedPackages.length === 0 ? null : selectedPackages} logTitle={"Waste Tracking Log"} accessToken={accessToken} clientAPIURL={clientAPIURL} projectId={projectId} /></View>
          //     <View style={CommonStyles.card}>
          //       <DbSpoilLog dateRange={dateRange} selectedPackage={selectedPackages.length === 0 ? null : selectedPackages} logTitle={"Spoil Tracking Log"} accessToken={accessToken} clientAPIURL={clientAPIURL} projectId={projectId} /></View>
          //     <View style={CommonStyles.card}>
          //       <DbHazardousMaterial dateRange={dateRange} selectedPackage={selectedPackages.length === 0 ? null : selectedPackages} logTitle={"Hazardous Material Storage Log"} accessToken={accessToken} clientAPIURL={clientAPIURL} projectId={projectId} /></View>
          //     <View style={CommonStyles.card}>
          //       <DbImportedSoilLog dateRange={dateRange} selectedPackage={selectedPackages.length === 0 ? null : selectedPackages} logTitle={"Imported Soil Log"} accessToken={accessToken} clientAPIURL={clientAPIURL} projectId={projectId} /></View>
          //     <View style={CommonStyles.card}>
          //       <DbRecycledMaterial selectedPackage={selectedPackages.length === 0 ? null : selectedPackages} logTitle={"Recycled Materials Log"} accessToken={accessToken} clientAPIURL={clientAPIURL} projectId={projectId} /></View>
          //     <View style={CommonStyles.card}>
          //       <DbRegionalMaterial selectedPackage={selectedPackages.length === 0 ? null : selectedPackages} logTitle={"Regional Materials Log"} accessToken={accessToken} clientAPIURL={clientAPIURL} projectId={projectId} /></View>
          //     <View style={CommonStyles.card}>
          //       <DbTrainingLog dateRange={dateRange} selectedPackage={selectedPackages.length === 0 ? null : selectedPackages} logTitle={"Training Log"} accessToken={accessToken} clientAPIURL={clientAPIURL} projectId={projectId} /></View>
          //     <View style={CommonStyles.card}>
          //       <DbNoiseLog dateRange={dateRange} selectedPackage={selectedPackages.length === 0 ? null : selectedPackages} logTitle={"Noise Monitoring Log"} accessToken={accessToken} clientAPIURL={clientAPIURL} projectId={projectId} /></View>
          //     <View style={CommonStyles.card}>
          //       <DbVibrationLog dateRange={dateRange} selectedPackage={selectedPackages.length === 0 ? null : selectedPackages} logTitle={"Vibration Monitoring Log"} accessToken={accessToken} clientAPIURL={clientAPIURL} projectId={projectId} /></View>
          //     <View style={CommonStyles.card}>
          //       <DbPM10 dateRange={dateRange} selectedPackage={selectedPackages.length === 0 ? null : selectedPackages} logTitle={"PM10 Monitoring Log"} accessToken={accessToken} clientAPIURL={clientAPIURL} projectId={projectId} /></View>
          //     <View style={CommonStyles.card}>
          //       <DbPM2P5 dateRange={dateRange} selectedPackage={selectedPackages.length === 0 ? null : selectedPackages} logTitle={"PM2.5 Monitoring Log"} accessToken={accessToken} clientAPIURL={clientAPIURL} projectId={projectId} /></View>

          //   </View>
          //   :
          //   <View><Text>Loading</Text></View>
        }
      </View>
    </ScrollView>
  )
}
export default HomeDashboard;
const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 22,
  },
  modalView: {
    margin: 20,
    backgroundColor: 'white',
    borderRadius: 20,
    padding: 35,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  button: {
    borderRadius: 20,
    padding: 10,
    elevation: 2,
  },
  buttonOpen: {
    backgroundColor: '#F194FF',
  },
  buttonClose: {
    backgroundColor: '#2196F3',
  },
  textStyle: {
    color: 'white',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  modalText: {
    marginBottom: 15,
    textAlign: 'center',
  },
});